// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-components-LeftNav-___Nav-module__container {
  height: 100%;
  display: flex;
}

.app-components-LeftNav-___Nav-module__leftContent {
  height: 100%;
  display: flex;
  flex-direction: column;
  border-right: var(--mainBorder);
  position: relative;
}

.app-components-LeftNav-___Nav-module__rightContent {
  flex: 1;
  position: relative;
  z-index: 10;
  background-color: var(--colors-greyExtraLight);
}

.app-components-LeftNav-___Nav-module__leftNav {
  flex: 1;
  background-color: var(--colors-yuzu-black);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  overflow: scroll;
  scrollbar-width: none;
}

.app-components-LeftNav-___Nav-module__openClose {
  display: flex;
  margin: 5px 0;
  align-items: center;
  color: var(--colors-greyLight);
  justify-content: center;
  cursor: pointer;
}

.app-components-LeftNav-___Nav-module__openCloseText {
  margin-right: 5px;
}
.app-components-LeftNav-___Nav-module__itemsContainer {
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 100%;
  height: 100%;
}
.app-components-LeftNav-___Nav-module__itemsContainer::-webkit-scrollbar-thumb {
  background-color: rgba(255, 255, 255, 0.08);
  border: solid 2px #41464d;
}
.app-components-LeftNav-___Nav-module__itemsContainer::-webkit-scrollbar-thumb:hover {
  border: solid 2px #41464d;
  background-color: rgba(255, 255, 255, 0.5);
}

/* Collapse */
.app-components-LeftNav-___Nav-module__resizeContainer {
  position: relative;
  width: 100%;
  height: 40px;
  color: #ffffff;
  cursor: pointer;
}
.app-components-LeftNav-___Nav-module__resizeInner {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  height: 100%;
}
.app-components-LeftNav-___Nav-module__resizeContainer:hover {
  background-color: rgba(0, 0, 0, 0.05);
}
`, "",{"version":3,"sources":["webpack://./app/components/LeftNav/Nav.module.scss"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,OAAO;EACP,kBAAkB;EAClB,WAAW;EACX,8CAA8C;AAChD;;AAEA;EACE,OAAO;EACP,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,2CAA2C;EAC3C,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA,aAAa;AACb;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,qCAAqC;AACvC","sourcesContent":[".container {\n  height: 100%;\n  display: flex;\n}\n\n.leftContent {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  border-right: var(--mainBorder);\n  position: relative;\n}\n\n.rightContent {\n  flex: 1;\n  position: relative;\n  z-index: 10;\n  background-color: var(--colors-greyExtraLight);\n}\n\n.leftNav {\n  flex: 1;\n  background-color: var(--colors-yuzu-black);\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  height: 100%;\n  overflow: scroll;\n  scrollbar-width: none;\n}\n\n.openClose {\n  display: flex;\n  margin: 5px 0;\n  align-items: center;\n  color: var(--colors-greyLight);\n  justify-content: center;\n  cursor: pointer;\n}\n\n.openCloseText {\n  margin-right: 5px;\n}\n.itemsContainer {\n  overflow-y: auto;\n  overflow-x: hidden;\n  max-height: 100%;\n  height: 100%;\n}\n.itemsContainer::-webkit-scrollbar-thumb {\n  background-color: rgba(255, 255, 255, 0.08);\n  border: solid 2px #41464d;\n}\n.itemsContainer::-webkit-scrollbar-thumb:hover {\n  border: solid 2px #41464d;\n  background-color: rgba(255, 255, 255, 0.5);\n}\n\n/* Collapse */\n.resizeContainer {\n  position: relative;\n  width: 100%;\n  height: 40px;\n  color: #ffffff;\n  cursor: pointer;\n}\n.resizeInner {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: row;\n  height: 100%;\n}\n.resizeContainer:hover {\n  background-color: rgba(0, 0, 0, 0.05);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `app-components-LeftNav-___Nav-module__container`,
	"leftContent": `app-components-LeftNav-___Nav-module__leftContent`,
	"rightContent": `app-components-LeftNav-___Nav-module__rightContent`,
	"leftNav": `app-components-LeftNav-___Nav-module__leftNav`,
	"openClose": `app-components-LeftNav-___Nav-module__openClose`,
	"openCloseText": `app-components-LeftNav-___Nav-module__openCloseText`,
	"itemsContainer": `app-components-LeftNav-___Nav-module__itemsContainer`,
	"resizeContainer": `app-components-LeftNav-___Nav-module__resizeContainer`,
	"resizeInner": `app-components-LeftNav-___Nav-module__resizeInner`
};
export default ___CSS_LOADER_EXPORT___;
